// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2sYTP","itemTitle":"ClientEmergencyInfo_itemTitle__3WEdY","itemText":"ClientEmergencyInfo_itemText__16jrK"};